import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const Wrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

export const SearchBox = styled.div`
  margin-bottom: 20px;
  max-width: 400px;
  position: relative;

  ${media.mobile} {
    max-width: 100%;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 48px;
  padding: 10px 14px 10px 40px;
  font-size: 14px;
  line-height: 21px;
  color: ${({ theme }) => theme.colors['neutral-90']};
  background-color: ${({ theme }) => theme.colors['neutral-20']};
  border: 2px solid transparent;
  border-radius: 8px;
  outline: none;
  transition: border-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1), background-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1);

  &::placeholder {
    color: ${({ theme }) => theme.colors['neutral-50']};
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors['primary-60']};
    background-color: ${({ theme }) => theme.colors['neutral-0']};
  }
`;

export const SearchIcon = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.colors['neutral-60']};
  font-size: 16px;
  pointer-events: none;
  display: flex;
  align-items: center;
`;

export const SelectionBar = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px;
  background-color: ${({ theme }) => theme.colors['secondary-20']};
  border-radius: 8px;
  margin-bottom: 12px;
  height: 48px;

  ${media.mobile} {
    padding: 0 12px;
    flex-wrap: wrap;
    height: auto;
    min-height: 48px;
    gap: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;

export const SelectionLabel = styled.span`
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors['primary-60']};
`;

export const CountLabel = styled.span`
  display: block;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors['neutral-60']};
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 64px 24px;
  color: ${({ theme }) => theme.colors['neutral-60']};
  font-size: 16px;
  line-height: 24px;
`;

export const LoadingState = styled.div`
  display: flex;
  justify-content: center;
  padding: 64px 0;
`;

export const Spinner = styled.span`
  width: 32px;
  height: 32px;
  border: 3px solid ${({ theme }) => theme.colors['neutral-20']};
  border-top-color: ${({ theme }) => theme.colors['primary-60']};
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const CheckboxCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid hsla(0, 0%, 0%, 0.16);
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  transition: border-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1), background-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1);

  &:checked {
    background-color: ${({ theme }) => theme.colors['primary-60']};
    border-color: ${({ theme }) => theme.colors['primary-60']};
  }

  &:checked::after {
    content: '';
    position: absolute;
    left: 3.5px;
    top: 1px;
    width: 5px;
    height: 8px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  &:indeterminate {
    background-color: ${({ theme }) => theme.colors['primary-60']};
    border-color: ${({ theme }) => theme.colors['primary-60']};
  }

  &:indeterminate::after {
    content: '';
    position: absolute;
    left: 2px;
    top: 5.5px;
    width: 8px;
    height: 2px;
    background: #fff;
    border-radius: 1px;
  }
`;

export const PaginationWrapper = styled.div`
  margin-top: 20px;

  ${media.mobile} {
    margin-top: 16px;
  }
`;
